/**
 * 接口域名管理
 **/
 const base = {    
  robotBaseUrl:process.env.VUE_APP_ROBOT_BASE_URL,//机器人相关接口域名
  wsBaseUrl:process.env.VUE_APP_WS_BASE_URL, //转人工/图片/普通文件接口域名
  wsUrl:process.env.VUE_APP_WS_URL, //知识库文件/坐席渠道/留言接口域名
}

export default base